import React from 'react';
import ReactLoading from 'react-loading';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'react-bootstrap';
import { Select } from '../components/fields';
import { PromoCard } from '../components/cards';
import { SavePromoModal } from '../components/modals';
import { Confirm, Toast } from '../components/alerts';
import { PromoService } from '../services';
import { LocalStorage } from '../utils';

import '../styles/promo.css';

class PromoPage extends React.Component {
  constructor(props) {
    super(props);

    const filter = LocalStorage.getFilter();

    this.state = {
      loading: false,
      venue: filter && filter.venue ? filter.venue : null,
      promos: [],
    };

    this.fetchPromos = this.fetchPromos.bind(this);
    this.addPromoBtnClick = this.addPromoBtnClick.bind(this);
    this.onVenueSelectChange = this.onVenueSelectChange.bind(this);
    this.onSavePromoComplete = this.onSavePromoComplete.bind(this);
    this.onPromoActionChange = this.onPromoActionChange.bind(this);

    this.promoService = new PromoService();
  }

  componentDidMount() {
    this.fetchPromos();
  }

  async fetchPromos() {
    this.setState({ loading: true });

    const { venue } = this.state;
    const result = await this.promoService.get({
      venue_id: venue ? venue._id : undefined,
    });

    if (result && result.success) {
      this.setState({
        promos: result.promos || [],
        venue: result.selected_venue,
        loading: false,
      });

      if (this.venueSelect && result.selected_venue) {
        this.venueSelect.setValue(result.selected_venue.name);
      }
    } else {
      this.setState({ promos: [], loading: false });
    }
  }

  addPromoBtnClick() {
    const { venue } = this.state;
    const { t } = this.props;

    if (venue) {
      this.savePromoModal.show(true, venue);
    } else {
      Toast.warning(t('Please select a venue from filter!'));
    }
  }

  onVenueSelectChange(venue) {
    this.setState({ venue }, this.fetchPromos);
  }

  onSavePromoComplete() {
    this.fetchPromos();
  }

  async onPromoActionChange(data, action) {
    const { t } = this.props;
    let result = null;

    switch (action.label) {
      case 'EDIT':
        this.savePromoModal.show(true, this.state.venue);
        this.savePromoModal.setFields(data);
        break;

      case 'DELETE': {
        const confirm = await Confirm.open(
          t('Promotion Deletion'),
          t('Are you sure to delete?'),
          t('Yes'),
          t('No')
        );

        if (confirm) {
          this.setState({ loading: true });
          result = await this.promoService.delete(
            data._id,
            this.state.venue._id
          );
        }
        break;
      }

      default:
        break;
    }

    if (result && result.success) {
      await this.fetchPromos();
    } else if (result) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, promos } = this.state;
    const { t, label, me } = this.props;

    return (
      <div className='content'>
        <SavePromoModal
          onRef={(ref) => (this.savePromoModal = ref)}
          onComplete={this.onSavePromoComplete}
        />

        <div className='content-title'>
          <div className='content-title-label'>{label}</div>

          <div className='content-title-buttons'>
            {(me.role === 'ADMIN' || me.role === 'MANAGER') && (
              <button
                className='content-title-button'
                onClick={this.addPromoBtnClick}
              >
                <FontAwesomeIcon icon={faPlus} /> {t('ADD PROMOTION')}
              </button>
            )}
          </div>
        </div>

        <div className='content-body'>
          <div className='content-header'>
            <Row>
              <Col md={12}>
                <p className='promo-container-title'>{t('Filters')}</p>
                <div className='promo-spacer' />
              </Col>

              <Col md={3}>
                <Select
                  fullWidth
                  type='venues'
                  field='name'
                  size='sm'
                  label={t('Venue')}
                  onChange={this.onVenueSelectChange}
                  onRef={(ref) => (this.venueSelect = ref)}
                />
              </Col>
            </Row>
          </div>

          {loading ? (
            <div className='margin-auto'>
              <ReactLoading
                type='spin'
                color='#000'
                height='24px'
                width='24px'
              />
            </div>
          ) : (
            <Row>
              <Col md={12}>
                <div className='promo-container'>
                  <p className='promo-container-title'>{t('Promotions')}</p>
                  <div className='promo-spacer' />

                  <div className='promo-container-inline'>
                    {promos && promos.length > 0 ? (
                      promos.map((promo) => (
                        <PromoCard
                          key={promo._id}
                          promo={promo}
                          data={promo}
                          actions={[
                            { label: 'EDIT', title: t('EDIT') },
                            {
                              label: 'DELETE',
                              title: t('DELETE'),
                              red: true,
                            },
                          ]}
                          onChange={this.onPromoActionChange}
                        />
                      ))
                    ) : (
                      <p className='promo-no-content'>{t('No Data Found')}</p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(PromoPage));
